<mat-toolbar color="primary">
    <span class="title-center">{{title}}</span>
</mat-toolbar>


<div class="cc-forms-container">

    <div class="filter">
        <mat-form-field>
            <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filter">
        </mat-form-field>
    </div>

    <mat-table class="mat-elevation-z8" #table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="select">
            <mat-header-cell style="flex-grow: 1;" *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle($event) : null" [checked]="this.selectedProjectTaskData.length && isAllSelected()"
                    [indeterminate]="!isAllSelected() && this.selectedProjectTaskData.length > 0">
                </mat-checkbox>
            </mat-header-cell>
            <mat-cell style="flex-grow: 1;" *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" [(ngModel)]="row.isActive" (change)="$event ? projectTaskChecked(row) : null">
                </mat-checkbox>
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="company">
            <mat-header-cell style="flex-grow: 1;" *matHeaderCellDef mat-sort-header> Company </mat-header-cell>
            <mat-cell style="flex-grow: 1;" *matCellDef="let row"> {{row.company}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="organization">
            <mat-header-cell style="flex-grow: 1;" *matHeaderCellDef mat-sort-header> Org </mat-header-cell>
            <mat-cell style="flex-grow: 1;" *matCellDef="let row"> {{row.organization}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="account">
            <mat-header-cell style="flex-grow: 1;" *matHeaderCellDef mat-sort-header> Account </mat-header-cell>
            <mat-cell style="flex-grow: 1;" *matCellDef="let row"> {{row.account}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="project">
            <mat-header-cell style="flex-grow: 2;" *matHeaderCellDef mat-sort-header> Project </mat-header-cell>
            <mat-cell style="flex-grow: 2;" *matCellDef="let row"> {{row.project}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="task">
            <mat-header-cell style="flex-grow: 3;" *matHeaderCellDef mat-sort-header> Task </mat-header-cell>
            <mat-cell style="flex-grow: 3;" *matCellDef="let row"> {{row.task}} </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>

    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    <mat-card fxLayout="row" fxLayoutGap="20px" fxLayoutAlign="center center">
        <button mat-raised-button color="warn" (click)="onCancel()">Cancel</button>
        <button mat-raised-button (click)="onSave()" color="primary">Save</button>
    </mat-card>
</div>






<!-- style="flex-grow: 1;"
style="flex-grow: 1;"
style="flex-grow: 1;"
style="flex-grow: 1;"
style="flex-grow: 5;"
style="flex-grow: 5;" -->